import { combineReducers } from "redux";

import web3Reucer from '../reducers/webReducer';
import walletConnection from '../reducers/walletConnection';

export default combineReducers({
    web3Reucer,
    walletConnection,
});